import { baseQuery } from '../baseQuery';

type PutTechnicianAwayStatusPayload = {
  technicianId: number;
  awayStatusId: number;
  start_date: string;
  end_date: string;
};

export const putTechnicianAwayStatus = async (payload: PutTechnicianAwayStatusPayload) => {
  const { technicianId, awayStatusId, ...rest } = payload;
  const { data } = await baseQuery(`technicians/${technicianId}/away-statuses/${awayStatusId}`, {
    type: 'PUT',
    body: {
      ...rest,
    },
  });

  return data;
};
